<template>
  <div class="app-container">
    <list ref="list" @change="onChange">
      <template slot="toolbar-right" v-if="$permission.canRead()">
          <el-button type="primary" @click="onExport" >导出</el-button>
      </template>
      <!-- <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template> -->
    </list>
    <!-- <div class="list-head" style="margin-top: 10px;">
      <span>明细信息</span>
    </div>
    <el-table class="tb-c-head" border :data="Details" v-loading="loading" show-summary>
      <template>
        <el-table-column prop label="单据类型" min-width="150px" show-overflow-tooltip />
        <el-table-column prop="DocNo" label="单据编号" />
        <el-table-column prop="DocDate" label="单据日期" min-width="120px">
          <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
        </el-table-column>
        <el-table-column prop="CustomerName" label="业务类型" />
        <el-table-column prop label="应付" />
        <el-table-column prop label="已付" />
        <el-table-column prop="Amount" label="金额" />
      </template>
    </el-table> -->
    <!-- <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/finance/dealings/machiningbill/list";
// import editDialog from "@/components/finance/dealings/ocost/editDialog";

export default {
  name: "machiningbill",
  mixins: [curdMixins],
  components: {
    list,
    // editDialog,
  },
  data() {
    return {
      // api,
      Details: [],
      loading: false,
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
    onChange(row) {
      // console.log("选中行", JSON.parse(JSON.stringify(row)));
      // this.Details = [];
      // this.api.list({ Id: row.OtherReceivId }).then((res) => {
      //   if (res.Code == 0) this.Details = res.Data;
      // });
    },
    create() {
      this.$refs.checkDialog.open();
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.AccountId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>